
import { Injectable } from '@angular/core';
import { FilterStateServiceBase } from '@services/filter-state.service.base'
import { IFilterBar } from '@shared/models/interfaces';

const ORDER_DEFAULTS: IFilterBar = {
  search: '',
  sort: 'Calibration Date',
  filter: '',
  searchBy: 'Last Name',
  direction: 'desc',
};

@Injectable({ providedIn: 'root' })
export class OrderStateService extends FilterStateServiceBase {
  constructor() {
    super({
      storageNamespace: 'order',
      defaultState: ORDER_DEFAULTS,
      extraResetKeys: ['orderSearchParent'], // previous behavior preserved
    });
  }
}

